export default __webpack_public_path__ + "static/media/Icon wrap.74e11ea1.svg";